import React from 'react'

export default React.createClass({

  render: function(){

  let edit;
    if(this.props.hideAllButtons !== true){
      edit = <a id='edit3' className='pull-down-xs-3' style={{float: 'right', fontSize: 16, textDecoration: 'underline'}} onClick={this.props.openUpdateInstructionsModal}>Edit</a>
    }
  return (
    <div className='row'>
      <hr style={{borderColor: '#c7c7c7', marginRight: -15, marginLeft: -15}}/>
      <div className='col-xs-12'>
        <div style={{fontSize: 24}}>
          <b className='pull-left'>Your additional instructions </b>
          {edit}
          </div>
          <div className='row'>
            <div className='col-xs-12'>
              <p className='pull-left' style={{paddingLeft: 10, fontStyle: 'italic', fontSize: 14}}>{this.props.name}</p>
          </div>
        </div>
      </div>
    </div>
  )
}})




// WEBPACK FOOTER //
// ./src/components/modals/components/instructions.jsx